import React, { useState } from 'react'
import { Modal } from '../components/common/Modal'

interface ContactModalProps {
  isOpen: boolean
  onClose: () => void
}

export function ContactModal({ isOpen, onClose }: ContactModalProps): React.ReactElement {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  })
  const [submitted, setSubmitted] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // Here you would typically send the form data to a backend
    console.log('Contact form submitted:', formData)
    setSubmitted(true)
    setTimeout(() => {
      setSubmitted(false)
      setFormData({ name: '', email: '', subject: '', message: '' })
      onClose()
    }, 2000)
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Contact Us" size="md">
      <div className="space-y-6">
        <div className="text-center">
          <div className="text-6xl mb-3">📧</div>
          <p className="text-gray-700 font-bold text-lg">
            Have a question or suggestion? We&apos;d love to hear from you!
          </p>
        </div>

        {submitted ? (
          <div className="p-8 bg-green-50 rounded-2xl border-4 border-green-300 text-center">
            <div className="text-6xl mb-3">✅</div>
            <h4 className="text-2xl font-black text-green-700 mb-2">Thank You!</h4>
            <p className="text-gray-700 font-bold">
              We&apos;ve received your message and will get back to you within 24 hours.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block font-black text-purple-700 mb-2">Your Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full p-3 border-4 border-purple-200 rounded-xl font-bold focus:outline-none focus:border-purple-400"
                placeholder="Enter your name"
              />
            </div>

            <div>
              <label className="block font-black text-purple-700 mb-2">Email Address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full p-3 border-4 border-purple-200 rounded-xl font-bold focus:outline-none focus:border-purple-400"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label className="block font-black text-purple-700 mb-2">Subject</label>
              <select
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                className="w-full p-3 border-4 border-purple-200 rounded-xl font-bold focus:outline-none focus:border-purple-400"
              >
                <option value="">Select a subject...</option>
                <option value="bug">Report a Bug</option>
                <option value="feature">Feature Request</option>
                <option value="feedback">General Feedback</option>
                <option value="support">Technical Support</option>
                <option value="partnership">Partnership Inquiry</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div>
              <label className="block font-black text-purple-700 mb-2">Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows={5}
                className="w-full p-3 border-4 border-purple-200 rounded-xl font-bold focus:outline-none focus:border-purple-400 resize-none"
                placeholder="Tell us what's on your mind..."
              />
            </div>

            <button
              type="submit"
              className="w-full py-3 bg-gradient-to-r from-purple-400 to-pink-400 text-white font-black rounded-full hover:from-purple-500 hover:to-pink-500 transition"
            >
              Send Message
            </button>
          </form>
        )}

        <div className="grid grid-cols-2 gap-4 pt-4 border-t-4 border-purple-200">
          <div className="text-center">
            <p className="text-3xl mb-2">💬</p>
            <p className="font-bold text-gray-700">Live Chat</p>
            <p className="text-sm text-gray-600">Mon-Fri, 9am-5pm</p>
          </div>
          <div className="text-center">
            <p className="text-3xl mb-2">📧</p>
            <p className="font-bold text-gray-700">Email</p>
            <p className="text-sm text-blue-500 font-bold">support@babykingdom.com</p>
          </div>
        </div>
      </div>
    </Modal>
  )
}
